/**
 * Created by laszlo.czondor on 2017. 11. 27.
 */
import VueScrollTo from 'vue-scrollto';

import distanceBetweenTwoCoordinates from '../../common/maps/distance-between-two-coordinates';

// import mock from './CSM01-customer-service-map.mock';
// import mock from '../SPM01-sales-points-map/SPM01-sales-points-map.mock.js';
import getCustomerServices from '../../common/api/get-customer-service';
import getSalesPoints from '../../common/api/get-sales-points';

const DEFAULT_CENTER = {lat: 46.3489077, lng: 18.6970103};
const TYPE = {
	CUSTOMER_SERVICE: 'customer-service',
	SALES_POINTS: 'sales-points'
}

export default {
	data() {
		return {
			userPlace: {},
			userPlaceAddress: '',
			userPlaceCoordinates: {},
			zoom: 17,
			center: DEFAULT_CENTER,
			customerServices: null,
			infoWindow: {
				isOpen: false,
				position: {
					lat: 0,
					lng: 0
				}
			},
			selected: {},
			hasError: false,
			autocompleteOptions: {
				bounds: {
					north: 48.6238540716,
					east: 22.710531447,
					south: 45.7594811061,
					west: 16.2022982113
				},
				strictBounds: true
			}
		}
	},
	props: {
		listContainerSelector: String,
		listItemPrefix: String,
		scrollDurationInMillisecs: {
			type: Number,
			default: 100
		},
		selectedCustomerServiceIdByDefault: {
			type: Number
		},
		defaultZoom: {
			type: Number,
			default: 17
		},
		searchButtonSelector: {
			type: String
		},
		type: {
			type: String,
			required: true
		}
	},
	methods: {
		getPlace() {
			this.$getLocation().then((coordinates) => {
				this.userPlaceCoordinates = coordinates;
				this.searchPlace();

				let geocoder = new window.google.maps.Geocoder();
				let latLng = new window.google.maps.LatLng(coordinates.lat, coordinates.lng);
				geocoder.geocode({location: latLng}, (result, status) => {
					if (status === 'OK' && result[0]) {
						let userPlace = result[0];

						this.userPlace = userPlace;
						this.userPlaceAddress = userPlace.formatted_address;
					}
				});
			})
		},
		setPlace(place) {
			this.userPlace = place;
			this.userPlaceCoordinates = {
				lat: place.geometry.location.lat(),
				lng: place.geometry.location.lng()
			};

			let searchButton = this.$el.querySelector(this.searchButtonSelector);
			searchButton.focus();
		},
		searchPlace() {
			if (this.userPlaceCoordinates.lat && this.userPlaceCoordinates.lng) {
				// calculate distance from searched place
				this.customerServices = this.customerServices.map((customerService) => {
					let customerServiceCoordinates = {
						lat: customerService.lat,
						lng: customerService.lng
					};
					let distance = distanceBetweenTwoCoordinates(this.userPlaceCoordinates, customerServiceCoordinates);

					customerService.distance = distance;
					return customerService;
				});

				this.customerServices.sort((a, b) => {
					return a.distance - b.distance;
				});

				// select first customer service nearest to user position
				this.selectCustomerService(this.customerServices[0]);
			}
		},
		changeZoom(value) {
			this.zoom = value;
		},
		selectDefaultCustomerService() {
			if (this.selectedCustomerServiceIdByDefault !== null || typeof this.selectedCustomerServiceIdByDefault !== 'undefined') {
				let selectedCustomerService = this.customerServices.find((customerService) => {
					return customerService.id === this.selectedCustomerServiceIdByDefault;
				});

				if (!selectedCustomerService) {
					selectedCustomerService = this.customerServices[0];
				}

				this.selectCustomerService(selectedCustomerService);
			}
		},
		selectCustomerService(customerService) {
			this.selected = customerService;
			this.infoWindow.isOpen = true;

			let newPosition = {
				lat: customerService.lat,
				lng: customerService.lng
			};

			this.infoWindow.position = newPosition;
			this.center = newPosition;
			this.zoom = this.defaultZoom;

			let customerServiceSelector = `${this.listItemPrefix}${customerService.id}`;
			setTimeout(() => {
				let customerServiceElement = document.querySelector(customerServiceSelector);
				VueScrollTo.scrollTo(customerServiceElement, this.scrollDurationInMillisecs, {
					container: this.listContainerSelector
				});
			});
		}
	},
	created() {
		(this.type == TYPE.CUSTOMER_SERVICE ? getCustomerServices : getSalesPoints)().then(({data}) => {
			this.customerServices = data.map((customerService) => {
				let id = parseInt(customerService.id, 10);
				let lat = parseFloat(customerService.lat, 10);
				let lng = parseFloat(customerService.lng, 10);
				customerService.id = id;
				customerService.lat = lat;
				customerService.lng = lng;
				return customerService;
			});
			this.selectDefaultCustomerService();
		}).catch(() => {
			this.hasError = true;
		})
	}
}



// WEBPACK FOOTER //
// ../source/modules/CSM01-customer-service-map/CSM01-customer-service-map.js